import { chunk, map } from 'lodash'
import { defaultTokenSymbol } from '@/helpers/MultiSendHandler.js'
export default {
  namespaced: true,
  state: {
    data: [],
  },
  actions: {
    onMouseEnter({ commit, state }, index) {
      const data = state.data.map((item, itemIndex) => {
        if (itemIndex === index) item.displayCopyIcon = true
        return item
      })
      commit('changeState', { data })
    },
    onMouseLeave({ commit, state }, index) {
      const data = state.data.map((item, itemIndex) => {
        if (itemIndex === index) item.displayCopyIcon = false
        return item
      })
      commit('changeState', { data })
    },
    async handleSending(
      { commit, state, dispatch },
      { multiSendHandler, editorData, maxAccountPerTrans, selectedToken, isSendSameValue }
    ) {
      commit('changeState', { data: [] })

      const isVip = await multiSendHandler.isVIP()
      const fee = isVip ? 0 : await multiSendHandler.txFee()
      const arr = chunk(editorData, maxAccountPerTrans)
      try {
        arr.map(async (item, index) => {
          const transactionInfo = await dispatch('convertArrayToString', item)
          const callback = function ({ completed }) {
            const trans = state.data[index]
            if (trans) {
              trans.loading = false
              trans.state = completed
            } else {
              const data = [...state.data, { loading: false, state: false, transactionInfo, displayCopyIcon: false }]
              commit('changeState', { data })
            }
          }
          const addresses = map(item, 'address')
          const values = map(item, 'amount')
          if (selectedToken.symbol === defaultTokenSymbol) {
            const res = !isSendSameValue
              ? await multiSendHandler.mutiSendETHWithDifferentValue(addresses, values, callback, fee)
              : await multiSendHandler.mutiSendETHWithSameValue(addresses, values[0], callback, fee)
            const data = [
              ...state.data,
              { index, hash: res, loading: true, state: false, transactionInfo, displayCopyIcon: false },
            ]
            commit('changeState', { data })
          } else {
            const res = !isSendSameValue
              ? await multiSendHandler.mutiSendCoinWithDifferentValue(addresses, values, selectedToken, callback, fee)
              : await multiSendHandler.mutiSendCoinWithSameValue(addresses, values[0], selectedToken, callback, fee)
            const data = [
              ...state.data,
              { hash: res, loading: true, state: false, transactionInfo, displayCopyIcon: false },
            ]
            commit('changeState', { data })
          }
        })
      } catch (e) {
        console.error(e)
      }
    },
    // eslint-disable-next-line no-empty-pattern
    convertArrayToString({}, array) {
      let s = ''
      array.map((item, index) => {
        const breakLine = array.length - 1 === index ? '' : '\n'
        if (item.isInvalidParam) s = s + `${item.text}${breakLine}`
        else s = s + `${item.address},${item.amount}${breakLine}`
      })
      return s
    },
  },
  mutations: {},
  getters: {},
}
